export default "__VITE_ASSET__CiVPOeiN__"